import { useCreateManufacturer } from '@/services/api/hooks/catalog';
import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Form } from '../../../components/form/Form';
import { TextField } from '../../../components/form/fields/text/TextInput';
import { Modal } from '../../../components/modal/Modal';
import { ModalProps } from '../../../components/modal/useModal';
import { Card } from '../../../components/sections/Card';

const CreateManufacturerFormFields = z.object({
  name: z.string()
});

type CreateManufacturerFormFields = z.infer<typeof CreateManufacturerFormFields>;

export const CreateManufacturerModal: FC<ModalProps> = props => {
  const createManufacturer = useCreateManufacturer();
  const methods = useForm<CreateManufacturerFormFields>({ resolver: zodResolver(CreateManufacturerFormFields) });

  const onSubmit = async (data: CreateManufacturerFormFields) => {
    await createManufacturer.mutateAsync({
      name: data.name
    });
    props.close();
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Create manufacturer</h1>
        </Modal.Controls>
        <Form className="flex w-full flex-col gap-3 py-2" methods={methods} onSubmit={onSubmit}>
          <TextField id="name" label="Name" />
          <Button
            loading={createManufacturer.isLoading}
            className="w-fit place-self-end"
            variant={ButtonVariant.Primary}
            type="submit"
          >
            Create
          </Button>
        </Form>
      </Card>
    </Modal>
  );
};
